import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { SITUACAO_ACORDAO } from '../../dominio/SituacaoAcordao';
import SituacaoAcordaoBusiness from '../../dominio/SituacaoAcordaoBusiness';
import SituacaoJulgamentoProcessoBusiness from '../../dominio/SituacaoJulgamentoProcessoBusiness';
import IconeAcordao from '../../img/IconeAcordao';
import BusinessError from '../../util/BusinessError';
import ErrorUtil from '../../util/ErrorUtil';
import StringUtil from '../../util/StringUtil';
import { Box } from '@mui/system';
import ReactComponent from '@/components/ReactComponent';

class SituacaoAcordao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            corIcone: computed,
            tooltip: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get corIcone() {
        let situacaoAcordao;

        try {
            situacaoAcordao = SituacaoAcordaoBusiness.getSituacaoAcordaoEscopoPublicacao(this.observableProps.registro);
        } catch (e) {
            if (e instanceof BusinessError) {
                if (
                    e.message.indexOf(
                        SituacaoAcordaoBusiness.MSG_ERRO_IDENTIFICACAO_SITUACAO_ACORDAO_PUBLICACAO_PROCESSO_NAO_JULGADO
                    ) === -1
                ) {
                    console.warn(e.message);
                }
            } else {
                console.error(ErrorUtil.montarMensagemErro(e));
            }

            return 'black';
        }

        return situacaoAcordao.cor;
    }

    get tooltip() {
        let formatoDataHoraEntrada = 'DD-MM-YYYY-HH-mm-ss';
        let formatoDataHoraSaida = 'DD/MM/YYYY [às] HH:mm:ss';
        let situacaoAcordao;
        let msg = '';

        try {
            situacaoAcordao = SituacaoAcordaoBusiness.getSituacaoAcordaoEscopoPublicacao(this.observableProps.registro);
            msg = 'Acórdão ';

            switch (situacaoAcordao) {
                case SITUACAO_ACORDAO.ASSINADO_ORIGEM:
                    msg += `${StringUtil.substituirPrimeiraLetraPorMinuscula(situacaoAcordao.descricao)} em ${moment(
                        this.observableProps.registro.dataAssinaturaSistemaOrigem,
                        formatoDataHoraEntrada
                    ).format(formatoDataHoraSaida)}`;
                    break;
                case SITUACAO_ACORDAO.ASSINADO_E_NAO_VERIFICADO:
                    msg += `assinado em ${moment(
                        this.observableProps.registro.informacoesAdicionais.dataAssinaturaAcordao,
                        formatoDataHoraEntrada
                    ).format(formatoDataHoraSaida)}, porém não marcado como validado pela Secretaria`;
                    break;
                case SITUACAO_ACORDAO.ASSINADO_E_VERIFICADO:
                    msg += `assinado em ${moment(
                        this.observableProps.registro.informacoesAdicionais.dataAssinaturaAcordao,
                        formatoDataHoraEntrada
                    ).format(formatoDataHoraSaida)}, e validado pela Secretaria`;
                    break;
                case SITUACAO_ACORDAO.DEVOLVIDO_PARA_CORRECAO:
                    msg += `${StringUtil.substituirPrimeiraLetraPorMinuscula(situacaoAcordao.descricao)} em ${moment(
                        this.observableProps.registro.informacoesAdicionais.dataDevolucaoAcordao,
                        formatoDataHoraEntrada
                    ).format(formatoDataHoraSaida)}`;
                    break;
                case SITUACAO_ACORDAO.NAO_PUBLICAVEL:
                    msg += StringUtil.substituirPrimeiraLetraPorMinuscula(situacaoAcordao.descricao);
                    break;
                case SITUACAO_ACORDAO.NAO_ASSINADO:
                    msg += StringUtil.substituirPrimeiraLetraPorMinuscula(situacaoAcordao.descricao);
                    break;
                default:
                    console.log(`Situação de acórdão não mapeada: ${situacaoAcordao}`);
                    break;
            }
        } catch (e) {
            if (e instanceof BusinessError) {
                if (
                    e.message.indexOf(
                        SituacaoAcordaoBusiness.MSG_ERRO_IDENTIFICACAO_SITUACAO_ACORDAO_PUBLICACAO_PROCESSO_NAO_JULGADO
                    ) === -1
                ) {
                    console.warn(e.message);
                }
            } else {
                console.error(ErrorUtil.montarMensagemErro(e));
            }
        }

        return msg;
    }

    render() {
        if (!SituacaoJulgamentoProcessoBusiness.isProcessoJulgado(this.registro?.resultadoJulgamento)) {
            return null;
        }

        return (
            <Tooltip title={<Typography>{this.tooltip}</Typography>}>
                <Box
                    as="span"
                    sx={{ display: 'flex', alignItems: 'center' }}
                >
                    <IconeAcordao sx={{ cursor: 'default', fillOpacity: '0.7', fill: this.corIcone }} />
                </Box>
            </Tooltip>
        );
    }
}

SituacaoAcordao.propTypes = {
    registro: PropTypes.object.isRequired
};

export default inject('stores')(observer(SituacaoAcordao));
